import { render, staticRenderFns } from "./WritingEnTopic.vue?vue&type=template&id=2c316e47"
import script from "./WritingEnTopic.vue?vue&type=script&lang=js"
export * from "./WritingEnTopic.vue?vue&type=script&lang=js"
import style0 from "./WritingEnTopic.vue?vue&type=style&index=0&id=2c316e47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports